import { TrackJS } from "trackjs";

interface TrackErrorOptions {
  componentName?: string;
  additionalData?: Record<string, any>;
  userId?: string;
  userRole?: string;
  action?: string;
}

export const errorTracking = (
  error: Error,
  options: TrackErrorOptions = {}
): void => {
  if (!TrackJS.isInstalled()) {
    console.error("TrackJS not installed, logging to console only:", error);
    return;
  }

  const { componentName, additionalData, userId, userRole, action } = options;

  TrackJS.addMetadata("componentName", componentName || "Unknown");
  TrackJS.addMetadata("url", window.location.href);
  TrackJS.addMetadata("route", window.location.pathname);
  TrackJS.addMetadata("userAgent", navigator.userAgent);
  TrackJS.addMetadata("timestamp", new Date().toISOString());

  if (action) TrackJS.addMetadata("action", action);

  if (userId) TrackJS.addMetadata("userId", userId);
  if (userRole) TrackJS.addMetadata("userRole", userRole);

  if (!userId && !userRole) {
    try {
      const auth_info = localStorage.getItem("auth_info");
      const account_index = JSON.parse(
        localStorage.getItem("account_index") || "0"
      );
      if (auth_info && account_index) {
        const userData = JSON.parse(auth_info)[account_index];
        TrackJS.addMetadata("userId", userData.id || "Unknown");
        TrackJS.addMetadata("userRole", userData.role || "Unknown");
      }
    } catch (e) {
      // Ignore errors from accessing localStorage
    }
  }

  if (additionalData) {
    Object.entries(additionalData).forEach(([key, value]) => {
      TrackJS.addMetadata(
        key,
        typeof value === "object" ? JSON.stringify(value) : String(value)
      );
    });
  }

  TrackJS.track(error);
};
